import { gql } from '@apollo/client';

export const BASKET_FILLED_STATUS = gql`
   query basketFilledStatus {
        isBasketFilled @client
    }
`;
